export const generateValues = (targetAverage) => {
  const targetSum = Math.round(targetAverage * 3);
  let values = [];

  for (let i = 0; i < 2; i++) {
    values.push(Math.floor(Math.random() * 3) + (targetSum / 3 - 1));
  }

  let thirdValue = targetSum - values.reduce((a, b) => a + b, 0);

  while (values.includes(thirdValue)) {
    values = [];
    for (let i = 0; i < 2; i++) {
      values.push(Math.floor(Math.random() * 3) + (targetSum / 3 - 1));
    }
    thirdValue = targetSum - values.reduce((a, b) => a + b, 0);
  }

  values.push(thirdValue);

  return values;
};

export const generateValues4 = (targetAverage) => {
  const targetSum = Math.round(targetAverage * 4);
  let values = [];

  for (let i = 0; i < 3; i++) {
    values.push(Math.floor(Math.random() * 3) + (targetSum / 4 - 1));
  }

  let fourthValue = targetSum - values.reduce((a, b) => a + b, 0);

  while (values.includes(fourthValue)) {
    values = [];
    for (let i = 0; i < 3; i++) {
      values.push(Math.floor(Math.random() * 3) + (targetSum / 4 - 1));
    }
    fourthValue = targetSum - values.reduce((a, b) => a + b, 0);
  }

  values.push(fourthValue);

  return values;
};

export const generateTwoValues = (targetAverage) => {
  console.log("this is target vaue",targetAverage)
  const targetSum = Math.round(targetAverage * 2);
  const possiblePairs = [];

  // Generate all valid pairs where values are close to each other (abs diff <= 2)
  for (let i = 0; i <= 15; i++) {
    const j = targetSum - i;
    if (
      j >= 0 && j <= 15 && i !== j &&
      Math.abs(i - j) <= 2 // Keep values close to each other
    ) {
      possiblePairs.push([i, j]);
    }
  }

  // If no such close pair exists, relax the condition and fallback to wider range
  if (possiblePairs.length === 0) {
    for (let i = 0; i <= 15; i++) {
      const j = targetSum - i;
      if (j >= 0 && j <= 15 && i !== j) {
        possiblePairs.push([i, j]);
      }
    }
  }

  // Still no valid pair (edge case)? Just split and clamp within 0-15
  if (possiblePairs.length === 0) {
    const fallback = Math.min(15, Math.floor(targetSum / 2));
    return [fallback, targetSum - fallback];
  }

  // Return a random pair from the valid list
  const randomIndex = Math.floor(Math.random() * possiblePairs.length);
  return possiblePairs[randomIndex];
};


